















import { Component, Vue } from "vue-property-decorator";
import SideNotification from "@/components/admin/notification/SideNotification.vue";

@Component({
    components: {
        SideNotification,
    },
})
export default class SocleNotificationApprovalWorkflowPage extends Vue {
    private isCreating = false;
    private notification: Notification | null = null;

    private cancel(): void {
        this.isCreating = false;
        this.notification = null;
    }
}
